// extracted by mini-css-extract-plugin
export default {"container":"LessonBuilder_container__MVIWF"};